import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { AppProvider } from "./config/AppContext";
import Login from "./components/login/Login";
import Application from "./components/application/Application";

export default function App() {
  return (
    <div>
      {window.location.pathname === "/" ||
      window.location.pathname === "/login" ? (
        <BrowserRouter>
          <Routes>
            <Route exact={true} path="/" element={<Login />} />
            <Route exact={true} path="/login" element={<Login />} />
          </Routes>
        </BrowserRouter>
      ) : (
        <AppProvider>
          <Application />
        </AppProvider>
      )}
    </div>
  );
}
